export function isMobileUser() {
	const windowWidth = window.innerWidth;

	return windowWidth <= 768;
}